<div class="time-picker-container">
  <div class="timeInput bg-fff"  [ngStyle]="showError()? {'border':'1px solid #B00020'}:{}">
    <!-- <mat-form-field appearance="outline" class="input-form-field time-picker-field">
      <mat-icon matPrefix svgIcon="clock"></mat-icon>
      <input
      matInput 
      readonly [ngModel]="value"
    
      class="time-picker input "
      placeholder="Time"
      [ngClass]="{'input-error': showError()}"
      (change)="this.onInputChange($event)">
   
    </mat-form-field> -->
    <!-- <input [placeholder]="'Time'" aria-label="Time"
       [ngModel]="value" class="time-input" 
       [ngxTimepicker]="fullTime"
        [format]="24"  readonly  
        (ngModelChange)="this.onInputChange($event)">
        <img src="assets/clock.svg"/>
      <ngx-material-timepicker #fullTime></ngx-material-timepicker> -->



      <input type="text" [(ngModel)]="value" (ngModelChange)="onInputChange($event)" placeholder="Time" (click)="openDropdown()" misToolTip
      [text]="'Invalid Time'" [position]="'top'" [showOnHover]="false" #input cdkOverlayOrigin class="time-input" />
    <img src="assets/clock.svg"/>
    <ng-template #dropdownContainer libDropdownScroll libTimepicker [originEl]="input" [openStatus]="openStatus" (statusEmitter)="closeDropdown()">
      <div *ngIf="openStatus" class="timepicker-dropdown" [ngStyle]="{ width: dropdownWidth || inputWidth }">
        <ul #dropdown>
          <li #timeInterval (click)="onTimeSelect(interval)" *ngFor="let interval of timeIntervals; index as i" [ngClass]="{ highlight: i === isHighlighted,'disabled': interval.includes('No') }">
            {{ interval | twelvehourtimeformatter}}
            <div class="ic-ui-check-24 selected-icon" *ngIf="interval === chosenTime"></div>
          </li>
        </ul>
      </div>
    </ng-template>

  </div>

  <div *ngIf="backdatedBooking;else bookingError">
    <div class="error-msg1" *ngIf="showBackdatedError">Booking should be in the past</div>
  </div>

  <ng-template #bookingError>
    <div class="error-msg1" *ngIf="showError() && formControl.errors.required"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{errorMessages.required}}</div>
    <div class="error-msg1" *ngIf="showError() && formControl.errors.pickupCutoff"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{formControl.errors.pickupCutoff}}</div>
    <div class="error-msg1" *ngIf="showError() && formControl.errors.order"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{formControl.errors.order}}</div>
  </ng-template>
</div>
